// extracted by mini-css-extract-plugin
export default {"plot":"LineChart_plot__afhM3","svg":"LineChart_svg__kAFjF"};